import { Box, Grid, Typography, List, ListItem, Avatar, Chip } from "@mui/material";
import moment from "moment";
import RectangleIcon from "@mui/icons-material/Rectangle";
import React from "react";
import { useNavigate } from "react-router-dom";

interface APIGatewayTableProps {
    columnFilters: any;
    gateways: any[]; // Using 'any' for flexibility with hardcoded data
    type: "active" | "pending" | "rejected";
}

const APIGatewayTable: React.FC<APIGatewayTableProps> = ({ type, gateways, columnFilters }) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();

    const statusColors = {
        active: "#12B76A",
        pending: "#FDB022",
        rejected: "#F04438",
    };

    const statusBgColors = {
        active: "#FFFFFF",
        pending: "#FDB02210",
        rejected: "#F0443810",
    };

    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        {columnFilters.name && <Grid item xs={2.5}><Typography fontSize="12px">GATEWAY NAME</Typography></Grid>}
                        {columnFilters.apiType && <Grid item xs={1.5}><Typography fontSize="12px">API TYPE</Typography></Grid>}
                        {columnFilters.endpointType && <Grid item xs={2}><Typography fontSize="12px">ENDPOINT TYPE</Typography></Grid>}
                        {columnFilters.region && <Grid item xs={1.5}><Typography fontSize="12px">REGION</Typography></Grid>}
                        {columnFilters.wafEnabled && <Grid item xs={1.5}><Typography fontSize="12px">WAF ENABLED</Typography></Grid>}
                        {columnFilters.solutionOwner && <Grid item xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>}
                        {columnFilters.createdAt && <Grid item xs={1.5} textAlign="start"><Typography fontSize="12px">CREATED ON</Typography></Grid>}
                    </Grid>
                </Box>
            </ListItem>
            {gateways.map((gw: any, index: number) => (
                <ListItem
                    key={gw.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        bgcolor: statusBgColors[type],
                        borderRadius: "8px",
                        cursor: "pointer",
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => setCardHoverIndex(null)}
                    onClick={() => navigate(`/apis-gateway/details/${gw.id}`)} // Updated navigation
                >
                    <Box width="100%">
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            {columnFilters.name && (
                                <Grid item xs={2.5}>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <RectangleIcon sx={{ color: statusColors[type], bgcolor: statusColors[type], width: "4px", marginRight: "8px" }} />
                                        <Typography fontSize="14px" fontFamily="Gilroy-Medium">
                                            {gw.name}
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                            {columnFilters.apiType && (
                                <Grid item xs={1.5}>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{gw.apiType}</Typography>
                                </Grid>
                            )}
                            {columnFilters.endpointType && (
                                <Grid item xs={2}>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{gw.endpointType}</Typography>
                                </Grid>
                            )}
                             {columnFilters.region && (
                                <Grid item xs={1.5}>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{gw.region}</Typography>
                                </Grid>
                            )}
                            {columnFilters.wafEnabled && (
                                <Grid item xs={1.5}>
                                    <Chip 
                                        label={gw.wafEnabled ? "Yes" : "No"} 
                                        size="small" 
                                        sx={{ 
                                            backgroundColor: gw.wafEnabled ? '#E6F9F0' : '#FEF3F2', 
                                            color: gw.wafEnabled ? '#027A48' : '#B42318',
                                            fontFamily: 'Gilroy-SemiBold'
                                        }} 
                                    />
                                </Grid>
                            )}
                            {columnFilters.solutionOwner && (
                                <Grid item xs={1.5}>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Avatar 
                                                src={gw.googleProfilePicture} // <-- USE the 'src' prop
                                                sx={{ marginRight: "8px", height: 30, width: 30, bgcolor: 'grey.300' }}
                                            >
                                                {/* This will show the first letter of the owner's name if the image is missing */}
                                                {gw.solutionOwner.charAt(0)} 
                                            </Avatar>
                                        <Typography fontSize="14px" fontFamily="Gilroy-Regular" noWrap>
                                            {gw.solutionOwner}
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                            {columnFilters.createdAt && (
                                <Grid item xs={1.5}>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography fontSize="14px" fontFamily="Gilroy-Regular">
                                            {moment(gw.createdAt).format("DD/MM/YYYY")}
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default APIGatewayTable;